import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box, CircularProgress } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface ArchiveUserModalProps {
  userName: string;
  onArchive: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const ArchiveUserModal: FC<ArchiveUserModalProps> = ({
  userName,
  onArchive,
  onCancel,
  isLoading = false,
}) => {
  return (
    <StatefulDialog
      name={DialogNames.ArchiveUser}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onArchive}
              disabled={isLoading}
            >
              { isLoading ? <CircularProgress color="info" size={26} /> : 'Archive' }
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to archive the user {userName}?</Typography>
      </Box>
    </StatefulDialog>
  )
}
